import React, { type ElementType } from 'react';
import type { Closer } from '../../api/types';
import { replaceNewLinesWithBr, useCloser } from '../../utils/projectUtils';

interface TextWithCloserNameProps {
  text: string;
  textWithCloserName?: string;
  closers: Array<Closer>;
  className?: string;
  as?: ElementType;
}

const TextWithCloserName = ({
  text,
  textWithCloserName,
  closers,
  className,
  as: Tag = 'p',
}: TextWithCloserNameProps): React.ReactElement => {
  const closer = useCloser(closers);

  return (
    <Tag className={className}>
      {replaceNewLinesWithBr(
        closer && textWithCloserName
          ? textWithCloserName.replace('{closerName}', closer.name)
          : text,
      )}
    </Tag>
  );
};

export default TextWithCloserName;
